import { NavigateFunction } from 'react-router-dom'

let navigate: NavigateFunction | null = null

export const setNavigation = (navigateFn: NavigateFunction) => {
  navigate = navigateFn
}

export const navigateTo = (path: string) => {
  if (navigate) {
    navigate(path)
  }
}
